import type { PaymentModuleId } from '@foundation/apis/payments';

import { execGet, execPost } from '@/services/utils/RequestUtils';

import { BraintreeMerchantInfo } from '../BraintreeClient';
import { ClientTokenApiResponse } from '../schemas/schemas';

export async function getBraintreeClientToken(
  paymentIntentId: string,
  moduleId: PaymentModuleId,
  accessToken: string,
): Promise<{ token: string; clientId?: string }> {
  const selectedPaymentMethod = moduleId;
  const response = await execPost<ClientTokenApiResponse>(
    'braintree/clienttoken',
    { paymentIntentId, selectedPaymentMethod },
    accessToken,
  );

  const data: { token: string; clientId?: string } = {
    token: response.token,
    clientId: response.clientId,
  };

  return data;
}

export async function getBraintreeSecureNonce(
  accessToken: string,
  paymentDataId?: string,
): Promise<string> {
  const response = await execPost<string>(
    'braintree/secureNonce',
    {
      paymentDataId: paymentDataId,
    },
    accessToken,
  );

  return response;
}

export async function getBraintreeMerchantInfo(
  paymentIntentId: string | undefined,
  legalEntityNumber: number | undefined,
  accessToken: string,
): Promise<BraintreeMerchantInfo> {
  let searchParams;

  if (paymentIntentId !== undefined) {
    searchParams = new URLSearchParams({
      paymentIntentId: paymentIntentId,
    });
  } else if (legalEntityNumber !== undefined) {
    searchParams = new URLSearchParams({
      legalEntityNumber: legalEntityNumber?.toString(),
    });
  } else {
    throw new Error(
      'Neither PaymentIntentId, nor legalEntityNumber was provided',
    );
  }

  const response = await execGet<BraintreeMerchantInfo>(
    `braintree/merchantdetails?${searchParams.toString()}`,
    accessToken,
  );

  return response;
}
